export default "__VITE_ASSET__JVF3PgTQ__"